export const importActions = Object.freeze({
  REVERT_IMPORT_VISIBILITY_CHANGE: 'REVERT_IMPORT_VISIBILITY_CHANGE',
  NEW_IMPORT_VISIBILITY_CHANGE: 'NEW_IMPORT_VISIBILITY_CHANGE',
});
